var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.525 7.155L5.52 1.647A1 1 0 004 2.492v11.016a.996.996 0 001 .992c.184 0 .365-.051.522-.147l9.003-5.509a.988.988 0 000-1.687v-.002zM5 13.496V2.5L13.99 8 5 13.496z",
    fill: "currentColor"
  })));
}
export default SvgPlay;